var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.994 2.006h-1.833c-.11 0-.166-.055-.166-.167V.673a.625.625 0 00-.333-.577.625.625 0 00-.667 0 .625.625 0 00-.333.577V3.84c0 .333-.167.5-.5.5-.333 0-.5-.167-.5-.5v-1.5c0-.222-.11-.333-.333-.333H5.164c-.11 0-.166-.055-.166-.166V.673a.625.625 0 00-.333-.577.625.625 0 00-.667 0 .625.625 0 00-.333.577V3.84c0 .333-.167.5-.5.5-.333 0-.5-.167-.5-.5v-1.5c0-.222-.11-.333-.333-.333h-1c-.367 0-.681.13-.942.39-.26.26-.39.575-.39.943v11.328C0 15.556.444 16 1.333 16h12.661c.889 0 1.333-.444 1.333-1.333V3.34c0-.889-.444-1.333-1.333-1.333zm-.333 12.661H1.666c-.222 0-.333-.11-.333-.333V6.338c0-.093.032-.171.097-.236a.321.321 0 01.236-.098H13.66c.222 0 .333.111.333.334v7.996c0 .222-.111.333-.333.333z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCalendar);
export default __webpack_public_path__ + "assets/images/icn-calendar.614126a0416c111b1f40334c787389ff.svg";
export { ForwardRef as ReactComponent };